module.exports = __webpack_public_path__ + "img/jd_logo.1aeff27b.svg";